/**
 * The product cards pinned on the homepage — the innovations holding a homepage
 * slot in the CMS, in slot order. The bundled four are the offline fallback;
 * `siteContent.ts` replaces the list once the CMS has answered.
 */

export interface InnovationCard {
    /** Last segment of the product page URL; also the CMS record id. */
    slug: string;
    /** Name with the last word split off — "Podus " + "AI" — the card colours it. */
    name: string;
    accent: string;
    logo: string;
    href: string;
    cta: string;
    paragraph: string;
}

/** "Podus AI" → "Podus " + "AI"; a one-word name is all accent. */
export function nameParts(name: string): { name: string; accent: string } {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length <= 1) return { name: '', accent: words[0] ?? '' };
    return { name: `${words.slice(0, -1).join(' ')} `, accent: words[words.length - 1] };
}

/** Button copy per product; anything the CMS adds beyond these reads "Learn More". */
export const CARD_CTA: Record<string, string> = {
    'podus-ai': 'Ask A Question',
    'podus-contract': 'Review A Contract',
    'podus-appointment': 'Book A Lawyer',
    'podus-legal-aid': 'Request Aid',
    'podus-checker': 'Run A Check',
    'podus-multidoor-court': 'Start A Case',
    'iris': 'Take The Screening',
};

/** The four product cards on the home page, as the CMS slots them. */
export const HOME_INNOVATIONS: InnovationCard[] = [];
